import { log } from "../utils/logger";

export default function generateDatasetFilters() {
  log(`%c[+] Generating mock[DATASET FILTERS]`, "color:green");

  // Exported Array
  const SAMPLE_DATA = [
    {
      filter_id_bint: 1,
      column_vch: "data.circuit_vch",
      display_vch: "Circuit",
      control_vch: "list",
      active_ti: 1,
      display_order_sint: 1,
    },
    {
      filter_id_bint: 2,
      column_vch: "data.voltage_vch",
      display_vch: "Voltage",
      control_vch: "list",
      active_ti: 1,
      display_order_sint: 2,
    },
    {
      filter_id_bint: 3,
      column_vch: "data.substation_vch",
      display_vch: "Substation",
      control_vch: "list",
      active_ti: 1,
      display_order_sint: 3,
    },
    {
      filter_id_bint: 4,
      column_vch: "data.district_vch",
      display_vch: "District",
      control_vch: "list",
      active_ti: 1,
      display_order_sint: 5,
    },
    {
      filter_id_bint: 5,
      column_vch: "data.city_vch",
      display_vch: "City",
      control_vch: "list",
      active_ti: 1,
      display_order_sint: 6,
    },
    {
      filter_id_bint: 6,
      column_vch: "data.priority_flag_vch",
      display_vch: "Priority Flag",
      control_vch: "radio",
      display_order_sint: 7,
    },
    {
      filter_id_bint: 7,
      column_vch: "data.customer_type_vch",
      display_vch: "Customer Type",
      control_vch: "check",
      display_order_sint: 8,
    },
    {
      filter_id_bint: 8,
      column_vch: "data.zip_vch",
      display_vch: "Zip",
      control_vch: "list",
      display_order_sint: 9,
    },
    {
      filter_id_bint: 9,
      column_vch: "data.county_vch",
      display_vch: "County",
      control_vch: "list",
      display_order_sint: 4,
    },
  ];

  return SAMPLE_DATA;
}
